import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApiEndPoints } from '../../../../models/api-endpoint';
import Toaster from '../../../../services/toaster.services';
import { toggleLoader } from '../../../../redux/actions/loader.action';
import RestApiService from '../../../../services/http-services';
import { useHistory } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import FileDownloadService from '../../../../services/file-download-services';

import "./ClusterCompare.scss"
import AppConstants from '../../../../core/constants/appConstants';
import { Delete } from '@material-ui/icons';
import DynamicTableList from '../../../../shared/components/commonui/DynamicTableList/DynamicTableList';
import NewSubHeaderComponent from '../../../../shared/components/new-sub-header/new-sub-header';

const ClusterComparison = (props: ClusterComparisonProps) => {

    const { toggleLoader } = props;
    const [comparisonData, setComparisonData] = useState<Array<any>>([]);
    const nodesCompareList: Array<any> | undefined = props.location?.state?.clusterCompareList;

    let history = useHistory();
    let fileDownloadService = new FileDownloadService();
    const nodeETId = AppConstants.SYSTEM_GENERATED_ETIDS.clustering.nodes.ETId;
    const nodeSV = AppConstants.SYSTEM_GENERATED_ETIDS.clustering.nodes.SV;

    function createComparision(cluster, resData, nodetotalRecord) {
        return {
            ...cluster,
            ...resData,
            isDeleted: true,
            envelopeCount: nodetotalRecord
        }
    }

    const getNodesInfo = useCallback((cluster: any, url: string) => {
        toggleLoader(true);
        RestApiService.invoke(ApiEndPoints.BLOCKCHAIN_INFO, null, { clusterUrl: url }, null, null).then(res => {
            RestApiService.invoke(ApiEndPoints.GET_ENVELOPE_COUNT, null, { url: url }, null, {
                ETId: nodeETId,
                SV: nodeSV
            }).then(nodeResponse => {
                // setComparisonData((prev) => [...prev, { ...cluster, ...res.data.data, isDeleted: true, envelopeCount: nodeResponse.data.totalRecord }])
                const nodeCompresion = createComparision(cluster, res?.data?.data, nodeResponse.data?.totalRecord);
                setComparisonData((prev) => [...prev,nodeCompresion ]);
                toggleLoader(false);

            }).catch(error => {
                toggleLoader(false);
                if (error.message === 'Network Error') {
                    Toaster.errorToasterWithId("getNodesInfo", error.message)
                }
                if (error?.response?.data?.errors?.length > 0) {
                    error.response.data.errors.forEach((response) => {
                        Toaster.errorToasterWithId("getNodesInfo", `${url} down`);
                    });
                }
            })
        }).catch(error => {
            setComparisonData((prev) => [...prev, {
                ...cluster,
                blockChainType: "N.A",
                blockChainHeight: "N.A",
                blockChainMempool: 'N.A',
                blockChainSize: "N.A",
                blockChainName: "N.A",
                envelopeCount: "N.A",
                isDeleted: false,
            }]);
            toggleLoader(false);
            if (error.message === 'Network Error') {
                Toaster.errorToaster(error.message)
            }
            if (error?.response?.data?.errors?.length > 0) {
                error.response.data.errors.forEach((response) => {
                    Toaster.errorToasterWithId("getNodesInfo", `${url} is down`);
                });
            }
        })
    }, [nodeETId, nodeSV, toggleLoader]);

    useEffect(() => {
        if (nodesCompareList?.length > 0) {
            nodesCompareList.forEach((cluster: any) => {
                getNodesInfo(cluster, cluster.NodeUrl);
            })
        }
    }, [getNodesInfo, nodesCompareList]);

    const downloadxls = () => {
        fileDownloadService.arrayOfObjectToXLSXFileDownload(comparisonData, "Node Comparison Result.xlsx");
    }

    const handleAction = useCallback((item: any, action: string) => {
        if (action === 'delete') {
            const elementDeleted = comparisonData.filter((compareObject) => compareObject.UID !== item.UID);
            setComparisonData(elementDeleted);
        }
    }, [comparisonData]);

    const renderStatus = useCallback((item: any) => {
        return (
            <div className='statusData'>
                {
                    item.data.isDeleted ? <span className='up status-box-style'>Up</span> : <span className='down status-box-style'>Down</span>
                }
            </div>
        )
    }, []);

    const ViewIconCellRenderer = useCallback((value: any): React.ReactNode => {
        return (
            <div className='role-icon'>
                <Tooltip title="Delete" placement="right">
                    < Delete color="primary" onClick={(e: any) => handleAction(value?.data, 'delete')} />
                </Tooltip>
            </div>
        )
    }, [handleAction]);

    const customActionColumnFormatters = [
        ViewIconCellRenderer
    ]

    const tableColumnList = useMemo(() => [
        { name: "Nodes", db: "NodeName", sort: false },
        { name: "BlockChain Type", db: "blockChainType", sort: false },
        { name: "Envelope Count", db: "envelopeCount", sort: false },
        { name: "Blockchain Height", db: "blockChainHeight", sort: false },
        { name: "Node Url", db: "NodeUrl" },
        { name: "Status", db: "isDeleted", cellRender: renderStatus }
    ], [renderStatus]);

    return (
        <div className="mainview">
            <div className="maincontent">
                <div className="dashboardcover">
                    <div className='setting-page cluster-node'>
                        <div className="Innerheading cluster-Compare">
                            <div className='view-wrapper view-wrapper-user-details dx-theme-background-color'>
                                <NewSubHeaderComponent
                                    headingText={'Comparison Result'}
                                    searchLabel={'Nodes'}
                                    btnText={"Export Result"}
                                    isbackEnabled
                                    onBackButtonClick={() => history.goBack()}
                                    onButtonClick={downloadxls}
                                    showBtn
                                />
                                <div className="dx-theme-background-color Innerdetails dx-card">

                                    <div className="grid grid-status">
                                       
                                        <DynamicTableList
                                            dataSource={comparisonData}
                                            columnList={tableColumnList}
                                            fromComponent={'SettingComponent'}
                                            showCustomActions
                                            customActionColumnFormatters={customActionColumnFormatters}
                                        />
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({

});

const mapDispatchToProps = () => (dispatch: any) =>
    bindActionCreators({ toggleLoader: toggleLoader }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ClusterComparison);


interface ClusterComparisonProps {
    toggleLoader: any;
    location: any;
}

ClusterComparison.defaultProps = {

}
